import { render } from "./FiCripto.vue?vue&type=template&id=e36777ee&scoped=true"
import script from "./FiCripto.vue?vue&type=script&lang=js"
export * from "./FiCripto.vue?vue&type=script&lang=js"

import "./FiCripto.vue?vue&type=style&index=0&id=e36777ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36777ee"]])

export default __exports__